import successFactors from './successFactors';
import competitors from './competitors';
import cpm from './cpm';
import processResources from './processResources';

export default {
    successFactors,
    competitors,
    cpm,
    processResources,
};
